<template>
    <div class="content row no-gutters" style="height: calc(100% - 50px) !important; top:50px;">
        <div class="main-empty w-100">

            <p class="main-text">
                <span id="load" @click="openLoadInstanceModal">{{ $t('UI_START_LOAD') }}</span> {{ $t('UI_START_TEXT') }}
                <span id="create" @click="openInstanceCreateDialog">{{ $t('UI_START_CREATE') }}</span> {{ $t('UI_START_TEXT2') }}
            </p>

            <sweet-modal :title="$t('UI_START_INSTANCE_SELECT_TITLE')" ref="loadModal" :blocking="true" :pulse-on-block="false">
                {{ $t('UI_START_INSTANCE_SELECT_TEXT') }}
                <v-select label="title"
                          :options="instances.list"
                          v-on:search:focus="expanded = true"
                          v-on:search:blur="expanded = false"
                          v-model="selectedInstance">
                  <template v-slot:option="instance">
                    <template v-if="instance.isLive">
                      <span style="float:left">{{ instance.title }}</span>
                      <span style="float:right; font-size: 14px" class="badge badge-danger">LIVE</span>
                      <div style="clear:both"></div>
                    </template>
                    <template v-else>
                      {{ instance.title }}
                    </template>
                  </template>
                </v-select>

                <div style="height: 330px;" v-if="expanded"></div>

                <div class="alert alert-warning mt-2" v-if="selectedInstance.locked" v-html="$t('ERROR_INSTANCE_ALREADY_LOCKED_MSG', {username: selectedInstance.locked_by})"></div>

                <div slot="button">
                    <button class="btn btn-danger" v-if="selectedInstance.locked" @click="acquireSelectedInstance(true, false)">
                        {{ $t('UI_MODEL_BUTTON_FORCE') }}
                    </button>
                    <button class="btn btn-primary ml-1" v-if="selectedInstance.locked" @click="acquireSelectedInstance(false, true)">
                        {{ $t('UI_MODEL_BUTTON_READ_ONLY') }}
                    </button>
                    <button class="btn btn-primary" @click="acquireSelectedInstance(false, false)" v-else>
                        {{ $t('UI_MODEL_BUTTON_SELECT') }}
                    </button>
                    <button class="btn btn-secondary ml-1" @click="closeLoadInstanceModel">
                        {{ $t('UI_MODAL_BUTTON_CLOSE') }}
                    </button>
                </div>
            </sweet-modal>


            <!-- Create instance -->
            <sweet-modal :title="$t('UI_START_INSTANCE_CREATE_TITLE')" ref="createInstanceModal" v-on:open="checkIfActiveChannelIsShared" :blocking="true" :pulse-on-block="false">
                <loading :active.sync="isLoading" :is-full-page="false"></loading>


                <div class="form-group">
                    <label for="title">{{ $t('UI_INSTANCE_CREATE_MODAL_TITLE') }}</label>
                    <input type="text" id="title" v-model="newInstance.title" class="form-control">
                </div>

                <div class="form-group" v-if="currentChannelShared && targetChannelList">
                    <label for="targetSelection">{{ $t('INSTANCE_CREATE_SHARED_TARGET_CHANNEL') }}</label>
                    <v-select label="title"
                              id="targetSelection"
                              :options="targetChannelList"
                              v-model="newInstance.selectedTargetChannel"
                              v-on:search:focus="expanded = true"
                              v-on:search:blur="expanded = false"
                    ></v-select>

                    <div style="height: 250px;" v-if="expanded"></div>
                </div>

                <div class="form-check mt-2">
                    <input type="checkbox" class="form-check-input" id="acquire" v-model="newInstance.acquire">
                    <label class="form-check-label" for="acquire">{{ $t('UI_START_INSTANCE_ACQUIRE') }}</label>
                </div>

                <div slot="button">
                    <button class="btn btn-primary" @click="createInstance">
                        {{ $t('UI_MODAL_BUTTON_CREATE') }}
                    </button>
                    <button class="btn btn-secondary ml-1" @click="closeInstanceCreateDialog">
                        {{ $t('UI_MODAL_BUTTON_CLOSE') }}
                    </button>
                </div>
            </sweet-modal>
        </div>
    </div>
</template>

<script>
import { SweetModal, SweetModalTab } from 'sweet-modal-vue';
import Loading from 'vue-loading-overlay';
import { RepositoryFactory } from '../../repositories/RepositoryFactory';

const InstanceRepository = RepositoryFactory.get('instances');
const ChannelSettingsRepository = RepositoryFactory.get('channelSettings');
const ChannelRepository = RepositoryFactory.get('adminChannels');

export default {
  name: 'DashboardHome',
  components: {
    SweetModal,
    SweetModalTab,
    Loading,
  },
  data() {
    return {
      isLoading: false,
      selectedInstanceLocked: false,
      instances: {
        list: [],
      },
      selectedInstance: {
        locked: false,
        locked_by: null,
      },
      newInstance: {
        title: '',
        acquire: true,
        selectedTargetChannel: null,
      },
      expanded: false,

      // Shared Channel: Target Selection
      currentChannelShared: null,
      targetChannelList: null,
    };
  },
  methods: {
    async checkIfActiveChannelIsShared() {
      this.isLoading = true;
      await ChannelSettingsRepository.fetchSettings()
        .then(res => this.currentChannelShared = this.$store.state.channelSettings.isShared)
        .finally((res) => {
          this.isLoading = false;
        });

      // If the current Channel is Shared, load a list of available channels to offer as a target
      if (this.currentChannelShared) {
        this.isLoading = true;
        await ChannelRepository.getAll()
          .then(res => this.targetChannelList = res.data.list)
          .finally((res) => {
            this.isLoading = false;
          });
      }
    },
    async createInstance() {
      await InstanceRepository.create({
        title: this.newInstance.title,
        acquire: this.newInstance.acquire,
        target: this.newInstance.selectedTargetChannel !== null ? this.newInstance.selectedTargetChannel.chid : null,
      })
        .then((response) => {
          if (this.newInstance.acquire) {
            InstanceRepository.refetchActive(false)
              .then(() => {
                this.$refs.createInstanceModal.close();
                this.$router.push({ name: 'InstanceManagement' });
              });
          }

          this.$refs.createInstanceModal.close();
          this.$snotify.info(this.$t('UI_INSTANCE_CREATED'));
          this.newInstance.title = '';
          this.newInstance.acquire = true;
        });
    },
    openInstanceCreateDialog() {
      this.$refs.createInstanceModal.open();
    },
    closeInstanceCreateDialog() {
      this.$refs.createInstanceModal.close();
    },
    async fetchInstances() {
      await InstanceRepository.getAll()
        .then((response) => {
          this.instances = response.data;
        })
        .catch((error) => {
        });
    },
    async acquireSelectedInstance(force = false, readonly = false) {
      if (!this.selectedInstance) {
        return false;
      }

      await InstanceRepository.acquire({
        id: this.selectedInstance.id,
        force,
        readonly,
      })
        .then((response) => {
          this.closeLoadInstanceModel();
          this.$store.dispatch('setInstanceData', response.data);
          this.$router.push({ name: 'InstanceManagement' });
          this.$snotify.info(this.$t('UI_INSTANCE_ACQUIRED', { instance: this.selectedInstance.title }));
        })
        .catch((error) => {
        });
    },
    openLoadInstanceModal() {
      this.fetchInstances();
      this.$refs.loadModal.open();
    },
    openCreateInstanceModal() {
      this.$refs.loadModal.open();
    },
    closeLoadInstanceModel() {
      this.$refs.loadModal.close();
    },
  },
};
</script>

<style scoped>

</style>
